import { render, staticRenderFns } from "./check_record.vue?vue&type=template&id=8b894972&scoped=true"
import script from "./check_record.vue?vue&type=script&lang=ts"
export * from "./check_record.vue?vue&type=script&lang=ts"
import style0 from "./check_record.vue?vue&type=style&index=0&id=8b894972&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b894972",
  null
  
)

export default component.exports